<script>
import { mapActions } from "vuex";
import i18n from "@/plugins/i18n";

export default {
  data() {
    return {
      formData: {},
      registerActive: false,
      showPassword: false,
      firstName: "",
      surname: "",

      userID: "",
    };
  },

  computed: {
    isButtonDisabled() {
      if (this.formData.userpwd != this.formData.userpwd2) {
        return true
      } else if (!this.formData.userpwd || !this.formData.userpwd2) {
        return true
      } else {
        return !this.passwordDisabled;
      }
    },
    passwordDisabled() {
      const hasLowercase = /[a-z]/.test(this.formData.userpwd);
      const hasUppercase = /[A-Z]/.test(this.formData.userpwd);
      const hasNumber = /[0-9]/.test(this.formData.userpwd);
      const isLong = (this.formData.userpwd.length > 7);
      const isNotMax = (this.formData.userpwd.length < 129);
      return hasLowercase && hasUppercase && hasNumber && isLong && isNotMax;
    },
  },

  methods: {
    ...mapActions("settings", ["getUserToken", "postUserToken", "registerToken", "resetPassword"]),
    getUserInfo() {
      let temp = window.location.search.split("?token=");
      this.token = temp[1];
      let params = {
        token: this.token,
      };
      this.getUserToken(params)
        .then((res) => {
          this.firstName = res.data[0].firstname;
          this.surname = res.data[0].surname;
          this.userID = res.data[0].user_id;
        })
        .catch(({ response }) => {
          // this.$router.push("/login");
          this.$toast.open({
            message: this.$parseResMessage(response.data.messageName),
            type: "error",
            duration: 5000,
            dismissible: true,
          });
        });
    },
    postUserInfo() {
      let temp = window.location.search.split("?token=");
      this.token = temp[1];
      let params = {
        token: this.token,
        userpwd: this.formData.userpwd,
      };
      this.postUserToken(params)
        .then((res) => {
          this.$router.push("/login");
          this.$toast.open({
            message: this.$parseResMessage(res.data.messageName),
            type: "success",
            duration: 5000,
            dismissible: true,
          });
        })
        .catch(({ response }) => {
          this.$toast.open({
            message: this.$parseResMessage(response.data.messageName),
            type: "error",
            duration: 5000,
            dismissible: true,
          });
        });
    },
    userToken() {
      const params = {
        token: window.location.search.split("?token="),
      }
      this.registerToken(params)
    },
    toLogin() {
      this.$router.push('/login')
    },

    resetUserPass() {
      const params = {
        user_id: this.userID,
        password: this.formData.userpwd
      }
      this.resetPassword(params)
        .then((res) => {
          this.$router.push("/login");
          this.$toast.open({
            message: this.$parseResMessage(res.data.messageName),
            type: "success",
            duration: 5000,
            dismissible: true,
          });
        })
        .catch(({ response }) => {
          this.$toast.open({
            message: this.$parseResMessage(response.data.messageName),
            type: "error",
            duration: 5000,
            dismissible: true,
          });
        });
    }
  },
  created() {
    this.getUserInfo();
  },
  watch: {},
};
</script>

<template>
  <div class="login-page">
    <div class="login-container">
      <div class="login-row" style="width: 75%">
        <div class="login-col">
          <div class="login-card">
            <img style="padding: 25px" src="/images/sustainfinity-logo.png" alt="sustainfinity-logo" />
            <div style="text-align: center">
              <p style="font-size: 200%; color: #61a60e">
                {{ $t("registerForm.hello") }} {{ this.firstName }}
                {{ this.surname }} !
              </p>
            </div>
            <p style="font-size: 120%; text-align: center;">
              {{ $t("register.password_conditions") }}
            </p>
            <form @submit.prevent style="margin-bottom: 1rem;" autocomplete="on">
              <div class="inputs">
                <input v-model="formData.userpwd" :type="showPassword ? 'text' : 'password'" class="custom-input"
                  :placeholder="$t('registerPass.password')" autocomplete="new-password" />
                <div class="password-icon-container">
                  <i class="fa-regular fa-eye show-password-icon" @click="showPassword = !showPassword"
                    v-if="showPassword == false"></i>
                  <i class="fa-regular fa-eye-slash show-password-icon" @click="showPassword = !showPassword"
                    v-if="showPassword == true"></i>
                </div>
              </div>

              <br />

              <div class="inputs">
                <input v-model="formData.userpwd2" :type="showPassword ? 'text' : 'password'" class="custom-input"
                  :placeholder="$t('registerPass.password_again')" autocomplete="new-password" />
                <div class="password-icon-container">
                  <i class="fa-regular fa-eye show-password-icon" @click="showPassword = !showPassword"
                    v-if="showPassword == false"></i>
                  <i class="fa-regular fa-eye-slash show-password-icon" @click="showPassword = !showPassword"
                    v-if="showPassword == true"></i>
                </div>
              </div>
              <br />
              <button class="save-button" style="font-size: larger;" @click="resetUserPass()"
                :disabled="isButtonDisabled" :class="{ 'disabled': isButtonDisabled }"> {{ $t("registerForm.save") }}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.login-container {
  position: fixed;
  top: 50%;
  left: 75%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  width: 85vh;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}

.login.row {
  display: flex;
  flex-wrap: wrap;
  margin-left: -15px;
  margin-right: -15px;
  width: 75%;
}

.login-col {
  flex: 0 0 100%;
  max-width: 100%;
  padding-left: 15px;
  padding-right: 15px;
}

.login-card {
  padding: 25px;
  border-radius: 5px;
  text-align: center;
  border: 2px solid rgb(214, 212, 212);
  max-width: 400px;
  width: 100%;
  display: flex;
  flex-direction: column;
  min-height: 400px;
  margin: auto;
  background-color: transparent
}

.inputs {
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 5px;
  margin-bottom: 5px;
}

.custom-input {
  width: 100%;
  border: none;
  padding: 10px;
  font-size: 16px;
  padding-right: 35px;
  border-radius: 5px;
  border: 1px solid transparent;
  transition: all 0.3s ease-in-out;
}

.custom-input:focus {
  border: 1px solid #0383ab;
  box-shadow: 0 0 5px 2px rgba(116, 177, 243, 0.973);
}

.save-button {
  width: 100%;
  background-color: #61a60e;
  color: white;
  padding: 12px;
  border: 1px solid transparent;
  border-radius: 5px;
  cursor: pointer;
  font-size: large;
  text-align: center;
  transition: background-color 0.3s ease;
  text-transform: uppercase;
  font-weight: bold;
}

.save-button:hover {
  background-color: #229863;

}

.save-button:disabled {
  background-color: #6c757d;
  cursor: not-allowed;
  border: 1px solid #28a745;
}

.password-icon-container {
  position: absolute;
  z-index: 10;
  right: .75em;
  top: 50%;
  transform: translateY(-50%);
}

.show-password-icon:hover {
  cursor: pointer;
  filter: brightness(125%);
  z-index: 99;
}
</style>
